<template>
    <div class="login page">
        <wrapper column :backgroundImage="background">
            <div class="image-container">
                <img src="@/assets/Login/top.png" alt="" width="100%" />
            </div>
            <div class="main">
                <div class="access-number">
                    <!-- 累積造訪人數：{{ formatAccessNumber }} -->
                </div>
                <rect-btn
                    shadow-color="rgba(171, 203, 216, 0.5)"
                    background-color="#daf0ff"
                    max-height="130px"
                    min-height="80px"
                    font-size="1.8em"
                    @click="onLogin"
                >
                    <div class="button-content">
                        <img src="@/assets/Login/line.png" alt="" />
                        <div class="text">LINE 登入</div>
                    </div>
                </rect-btn>
                <rect-btn
                    shadow-color="rgba(208, 185, 158, 0.5)"
                    background-color="#fce6d1"
                    max-height="130px"
                    min-height="80px"
                    font-size="1.8em"
                    @click="goToRoute('Home')"
                >
                    <div class="button-content">
                        <img src="@/assets/Login/guest.png" alt="" />
                        <div class="text">訪客體驗</div>
                    </div>
                </rect-btn>
            </div>
            <div class="image-container">
                <img src="@/assets/Login/footer.png" alt="" width="100%" />
            </div>
        </wrapper>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import liff from '@line/liff';
import PageGeneral from '@/mixins/PageGeneral';

export default {
    mixins: [PageGeneral],
    data() {
        return {
            accessNumber: 10000,
        };
    },
    computed: {
        ...mapState({
            liffInitFail: 'liffInitFail',
        }),
        formatAccessNumber() {
            return Intl.NumberFormat('en-US').format(this.accessNumber);
        },
    },
    methods: {
        ...mapMutations({
            setUser: 'setUser',
            setContactFormState: 'setContactFormState',
        }),
        onLogin() {
            if (this.liffInitFail) {
                alert('無法初始化line服務，請使用訪客體驗遊玩遊戲');
            } else liff.login();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../scss/main.scss";
.access-number {
    font-size: 14px;
}
.main {
    justify-content: center;
    > * {
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .button-content {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            margin: 0 15px;
            width: 70px;
            height: 70px;
            border-radius: 50%;
        }
        .text {
            margin-right: 15px;
        }
    }
}
</style>
